export const AI_MODEL_NAME = {
  HG_ASSISTANT: 'HG_AI_AssistantForUI'
}

export const AI_PROMPT_TONE = {
  Friendly: 'Friendly',
  Formal: 'Formal',
  Technical: 'Technical',
  SEO: 'SEO',
};

export const TONE_PROMPT = {
  [AI_PROMPT_TONE.Friendly]: 'Friendly - Craft a warm and engaging description, using approachable language while maintaining professionalism, making it easy to understand.',
  [AI_PROMPT_TONE.Formal]: 'Formal - Write in a polished and professional tone, utilizing formal language that conveys authority and credibility while ensuring clarity and respectfulness.',
  [AI_PROMPT_TONE.Technical]: 'Technical - Provide an in-depth, precise explanation with technical language, focusing on accuracy and detailed specifications, ensuring the content is suitable for a knowledgeable audience.',
  [AI_PROMPT_TONE.SEO]: 'SEO - Create a search-engine optimized description with clear and concise information, incorporating relevant keywords and phrases to enhance visibility and ranking on search engines.',
};

export const AI_PROMPT_LENGTH = {
  Short: 'Short',
  Normal: 'Normal',
  Summarized: 'Summarized',
};

export const LENGTH_PROMPT = {
  [AI_PROMPT_LENGTH.Short]: 'Short - Write a brief and concise description, covering only the essential information in a few sentences.',
  [AI_PROMPT_LENGTH.Normal]: 'Normal - Write a detailed and comprehensive description, balancing clarity and completeness while covering all important aspects.',
  [AI_PROMPT_LENGTH.Summarized]: 'Summarized - Provide a summary that concisely presents the key details and insights, ensuring clarity and completeness.',
};

export const USER_INPUT_TEMPLATE_PROMPT = `Additional context from the user: [userInput]`;

export const USER_LANGUAGE_PROMPT = `The result text must be in "[language]" language, but "Products", "Tools" names can be in other languages.`;
